(function () {
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .factory('BaseFilterType', BaseFilterTypeClass)
      .service('FiltersHelper', FiltersHelper);

  function BaseFilterTypeClass(FiltersHelper) {

    function BaseFilterType(filterData, stateParams) {
      if (!(this instanceof BaseFilterType)) return new BaseFilterType(filterData, stateParams);

      this.filterData = filterData;
      this.stateParams = stateParams;
    }

    _.extend(BaseFilterType.prototype, {
      values: values,
      /**
       * function to format filter values from API to a standard format
       */
      formatFilterValues: unimplemented('formatFilterValues'),
      /**
       * function to get the default selected filter options
       */
      selectedParams: unimplemented('selectedParams'),
      /**
       * function to check if the filter should be selected
       */
      isFilterSelected: unimplemented('isFilterSelected')
    });

    function unimplemented(method) {
      return function () {
        console.error(new Error('#' + method + ' not implemented'));
      };
    }

    function values() {
      var formattedFilter = this.formatFilterValues(this.filterData);
      var params = this.selectedParams(this.stateParams);
      var isSelected = this.isFilterSelected(params);
      return FiltersHelper.filtersWithDefault(formattedFilter, isSelected);
    }

    return BaseFilterType;
  }


  function FiltersHelper() {

    return {
      formatFlatFilter: formatFlatFilter,
      formatTreeFilter: formatTreeFilter,
      filtersWithDefault: filtersWithDefault,
      includesDefaultFn: includesDefaultFn,
      equalsDefaultFn: equalsDefaultFn
    };

    function formatFlatFilter(arr) {
      return _(arr).map(function (value) {
        return {'name': value, 'isSelected': false}   // by Default all selected
      }).value();
    }

    function formatTreeFilter(arr) {
      return _(arr).map(function (valObj) {
        return {
          name: valObj.name,
          isSelected: false,
          isCollapsed: true,
          values: (valObj['dimensionType'] === 'tree') ?
              formatTreeFilter(valObj.values) : formatFlatFilter(valObj.values)
        }
      }).sortBy('name').value();
    }

    function filtersWithDefault(formattedFilterArr, defaultFns) {
      return _(formattedFilterArr).map(function (valObj) {
        valObj.isSelected = _.head(defaultFns)(valObj);
        if(!_.isUndefined(valObj.values) && valObj.isSelected){    // To ensure child is selected only when parent is selected
          filtersWithDefault(valObj.values, _.tail(defaultFns));
        }
        return valObj;
      }).value();
    }

    function includesDefaultFn(stateParams) {
      return function (valObj) {
        return stateParams && _.includes(stateParams, valObj.name);
      }
    }

    function equalsDefaultFn(stateParams) {
      return function (valObj) {
        return stateParams && _.eq(stateParams, valObj.name);
      }
    }
  }
})();